import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";

export default function DeleteConfirmModal({
  open,
  title = "Confirmar exclusão",
  message = "Tem certeza que deseja excluir este item?",
  onCancel,
  onConfirm,
}) {
  const [dontAskAgain, setDontAskAgain] = useState(false);

  useEffect(() => {
    if (open) setDontAskAgain(false);
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-black/55 px-4">
      <button
        type="button"
        aria-label="Fechar confirmação de exclusão"
        className="absolute inset-0"
        onClick={onCancel}
      />
      <div className="relative z-[121] w-full max-w-md rounded-xl border border-white/10 bg-cp-bg p-5 shadow-2xl">
        <div className="flex items-start gap-3">
          <div className="mt-0.5 rounded-full bg-red-500/15 p-2 text-red-300">
            <AlertTriangle className="h-4 w-4" />
          </div>
          <div className="min-w-0">
            <h3 className="text-base font-semibold text-slate-100">{title}</h3>
            <p className="mt-1 text-sm leading-relaxed text-slate-400">{message}</p>
          </div>
        </div>

        <label className="mt-4 flex cursor-pointer items-center gap-2 text-sm text-slate-300">
          <input
            type="checkbox"
            checked={dontAskAgain}
            onChange={(e) => setDontAskAgain(e.target.checked)}
            className="h-4 w-4 rounded border-white/20 bg-cp-elevated text-cp-primary focus:ring-cp-primary/40"
          />
          Não perguntar novamente
        </label>

        <div className="mt-5 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-lg border border-white/15 px-3 py-2 text-sm font-medium text-slate-300 hover:bg-white/5"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={() => onConfirm(dontAskAgain)}
            className="rounded-lg border border-red-400/35 bg-red-500/10 px-3 py-2 text-sm font-semibold text-red-300 hover:bg-red-500/20"
          >
            Excluir
          </button>
        </div>
      </div>
    </div>
  );
}
